import {classToPlain, Exclude, Expose, plainToClass} from "class-transformer";
import * as t from "io-ts";
import {validateJSON} from "../web/validation";
import {Entity} from "./entity";

export const ServiceTypeFreightTypeAssocValidator = t.intersection([
  t.type({
    id: t.string,
    serviceTypeId: t.string,
    waterTypeId: t.string,
    regionId: t.string,
    preferenceRank: t.number,
    lastModifiedDttm: t.number,
    createDttm: t.number,
  }),
  t.partial({
    waterTypeName: t.string,
  }),
]);

export const ServiceTypeFreightTypeAssocArrayValidator = t.array(
  ServiceTypeFreightTypeAssocValidator
);

export type ServiceTypeFreightTypeAssoc = t.TypeOf<
  typeof ServiceTypeFreightTypeAssocValidator
>;
export type ServiceTypeFreightTypeAssocArray = t.TypeOf<
  typeof ServiceTypeFreightTypeAssocArrayValidator
>;

@Exclude()
export class ServiceTypeFreightTypeAssocEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  serviceTypeId!: string;

  @Expose({name: 'waterTypeId'})
  freightTypeId!: string;

  @Expose()
  regionId!: string;

  @Expose()
  preferenceRank!: number;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  // extras
  @Expose({name: 'waterTypeName'})
  freightTypeName?: string;

  readonly entityType = 'SERVICEWATERASSOC';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for ServiceTypeFreightTypeAssocEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  /**
   * Create a ServiceTypeFreightTypeAssocEntity from a type value.
   *
   * @param assoc the type value.
   */
  static from(
    assoc: ServiceTypeFreightTypeAssoc
  ): ServiceTypeFreightTypeAssocEntity {
    const entity: ServiceTypeFreightTypeAssocEntity = plainToClass(
      ServiceTypeFreightTypeAssocEntity,
      assoc,
      {
        excludeExtraneousValues: true,
      }
    );
    return entity;
  }

  /**
   * Deserializes the ServiceTypeFreightTypeAssocEntity to a ServiceTypeFreightTypeAssoc type value.
   * If validation fails, the promise will be rejected.
   */
  toTypeValue(): Promise<ServiceTypeFreightTypeAssoc> {
    const object = classToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ServiceTypeFreightTypeAssocValidator, object);
  }
}
